import App from '@/models/App'

export default class ShipLaborBoardingSailor extends App {
    static get entity() {
        return 'ShipLaborBoardingSailor'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static fields() {
        return {
            id: this.attr(''),
            shipId: this.attr(''),
            boardingAt: this.attr(''),
            disembarkAt: this.attr(''),
        }
    }
    static apiConfig = {
        actions: {
            fetch(shipSailorId) {
                return this.get(`sailors/${shipSailorId}/boardings`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
